import type {
  ArtifactResourceListResponseV2Api,
  EnumArtifactComponentTypeApi,
  EnumArtifactTypeApi as EnumArtifactTypeApiV2,
  TemplateResourceListResponseV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import { toString } from 'lodash-es';
import type {
  DeviceManagementArtifact,
  DeviceManagementArtifactResponse,
  DeviceManagementArtifactTypeApi,
} from '../../models/deviceManagementArtifacts.model';
import {
  DeviceManagementArtifactComponentType,
  DeviceManagementArtifactType,
} from '../../models/deviceManagementArtifacts.model';

export function mapArtifactType(artifactType: EnumArtifactTypeApiV2): DeviceManagementArtifactTypeApi {
  return artifactType === 'SW_PACKAGE' ? DeviceManagementArtifactType.SwPackage : DeviceManagementArtifactType.Template;
}

export function mapArtifactComponentType(
  artifactType: EnumArtifactComponentTypeApi | string,
): DeviceManagementArtifactComponentType {
  const normalizedArtifactType = String(artifactType ?? '').toUpperCase();

  if (normalizedArtifactType === 'APPLICATION') {
    return DeviceManagementArtifactComponentType.Application;
  }
  if (normalizedArtifactType === 'OS') {
    return DeviceManagementArtifactComponentType.OS;
  }
  if (normalizedArtifactType === 'OTHER') {
    return DeviceManagementArtifactComponentType.Other;
  }
  if (normalizedArtifactType === 'RESOURCE') {
    return DeviceManagementArtifactComponentType.SystemPackage;
  }
  return DeviceManagementArtifactComponentType.SystemPackage;
}

export function mapDeviceManagementSystemPackageTemplatesResponse({
  data,
  pagination,
}: TemplateResourceListResponseV2Api): DeviceManagementArtifactResponse {
  return {
    pagination,
    data: data.map<DeviceManagementArtifact>(
      ({
        templateFileName,
        id,
        targetLocation,
        templateFileId,
        size,
        templateFileVersion,
        name,
        mimeType,
        checksum,
        componentType,
        createdBy,
        creationDate,
        fileName,
        type,
        description,
      }) => ({
        id: toString(id),
        name: toString(name),
        size: size ?? 0,
        targetLocation: toString(targetLocation),
        templateFileId: toString(templateFileId),
        templateFileVersion,
        templateFileName,
        mimeType,
        checksum,
        componentType: mapArtifactComponentType(componentType),
        createdBy,
        creationDate,
        fileName,
        type: mapArtifactType(type),
        description,
      }),
    ),
  };
}
export function mapDeviceManagementArtifactsV2Response({
  data,
  pagination,
}: ArtifactResourceListResponseV2Api): DeviceManagementArtifactResponse {
  return {
    pagination,
    data: data.map((artifact) => ({
      ...artifact,
      name: artifact.fileName,
      type: mapArtifactType(artifact.type),
      componentType: mapArtifactComponentType(artifact.componentType as EnumArtifactComponentTypeApi | string),
    })),
  };
}
